/* eslint-disable no-underscore-dangle */
import { BlipChat } from 'blip-chat-widget';
import { useEffect } from 'react';

import { CHAT_CLOSE_ICON_URL, CHAT_ICON_URL } from '@/constants';
import { useGlobal, useTracker } from '@/hooks';

export const botClient = new BlipChat();

export const useBot = (message: string) => {
  const global = useGlobal();
  const tracker = useTracker();

  useEffect(() => {
    botClient
      .withAppKey(process.env.BOT_TOKEN)
      .withAccount({
        extras: {
          company_id: global?.user?.data?.company?.id,
          user_id: global?.user?.data?.id,
          user_name: global?.user?.data?.name,
          user_email: global?.user?.data?.email,
          url: document.location.hostname + document.location.pathname,
          dominio_site: document.domain,
          mensagem_chat: message,
          cmp_params: document.location.search,
        },
      })
      .withButton({ color: '#2CC3D5', icon: '' })
      .withCustomCommonUrl('https://fretebras.chat.blip.ai/')
      .build();

    const blipChatIcon = document.getElementById('blip-chat-icon') as HTMLImageElement;
    const blipChatCloseIcon = document.getElementById('blip-chat-close-icon') as HTMLImageElement;
    const blipChatOpenIframe = document.getElementById('blip-chat-open-iframe');
    const container = document.createElement('div');
    const mainMessageContent = `<span id='main-message'>${message}<span id='seta'></span></span>`;

    container.innerHTML = mainMessageContent;
    blipChatOpenIframe.parentNode.insertBefore(container, blipChatOpenIframe);

    const mainMessage = document.getElementById('main-message');

    blipChatIcon.src = CHAT_ICON_URL;
    blipChatIcon.onclick = () => {
      tracker.dispatchWithUserData('risk_onboarding_home_chat_clicked');
      mainMessage.style.display = 'none';
    };

    blipChatCloseIcon.src = CHAT_CLOSE_ICON_URL;
    blipChatCloseIcon.onclick = () => {
      mainMessage.style.display = 'block';
    };

    mainMessage.onclick = () => {
      mainMessage.style.display = 'none';
      tracker.dispatchWithUserData('risk_onboarding_home_chat_clicked');
      botClient?.widget?._openChat?.();
    };

    return () => {
      mainMessage.style.display = 'none';
      blipChatOpenIframe.style.display = 'none';
    };
  }, []);
};
